import mixpanel from 'mixpanel-browser';
// Firebase
import { db, auth, storage } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, serverTimestamp, orderBy, increment, startAfter, limit, onSnapshot } from 'firebase/firestore';
import { ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';

import {
    GET_MATCH,
    GET_MATCHES,
    SET_MATCHES,
    SET_LAST_MATCHES,
    MATCH_ERROR,
    CLEAR_MATCHES,
    CLEAR_MATCH,
    MATCHES_LOADING,
    UPDATE_MATCH,
    MATCH_UPDATE_LOADED,
    MATCH_UPDATE_LOADING,
    SET_SHOW_BOTTOM_SPINNER_4_MATCHES,
    SET_LAST_MATCH_DOC,
    SET_NO_MORE_MATCHES
} from './types';
import { setAlert } from './alertActions';
import { followMatch } from './authActions';

// Reference to collections in Firestore
const sportsCollectionRef = collection(db, "sports_matches");

// Get group by id
export const getMatchById = id => async dispatch => {

    // Dispatch the clearMatch action to reset the user state
    dispatch(clearMatch());
    try {
        const docRef = doc(db, 'sports_matches', id)

        // Retrieve the document with the specified id from the collection
        const groupDoc = await getDoc(docRef);
        
        console.log('GOT MATCH BY ID');

        if(groupDoc.data()) {

            const groupData = {
                ...groupDoc.data(),
                _id: id
            }

            // Dispatch an action of type GET_POST with the post data and ID as the payload
            dispatch({
                type: GET_MATCH,
                payload: groupData
            });
        } else {
            dispatch({
                type: GET_MATCH,
                payload: null
            });

            dispatch(setAlert("Sorry, this sports match doesn't exist.", 'okay'));
        }
    } catch (err) {

        // If an error occurs, dispatch the MATCH_ERROR action with an error message and status code as the payload
        dispatch({
            type: MATCH_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        console.log(err);
    }
}

// Get sports matches by sport type
export const getMatchesBySportType = ({ sport_type, group_id, lastPageDoc }) => async dispatch => {
    
    console.log('ABOUT TO GET MATCHES BY SPORT TYPE');

    // dispatch(clearMatches());
    if(!lastPageDoc) dispatch(setMatchesLoading());

    const PAGE_LIMIT = 15;

    try {
        const matchesList = await getMatchesBySportType_Helper({ sport_type, group_id, lastPageDoc, page_size: PAGE_LIMIT });

        let lastDocument = matchesList[matchesList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified document 
            const docRef = doc(sportsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID
            const sportsMatchDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch(set_LastPageDoc(sportsMatchDoc));

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action to update the state
        if(matchesList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_MATCHES,
                payload: matchesList
            });
        } else {
            dispatch({
                type: SET_MATCHES,
                payload: matchesList
            });
        }

    } catch (err) {
        console.log("ERROR! HELPER FAILED TO GET MATCHES BY SPORT TYPE")
        console.log(err);

        // Dispatch an action to handle the error
        dispatch({
            type: MATCH_ERROR,
            payload: []
        })
    }
};

// Fill the matches array with everything in the given array
export const setMatches = arrayOfMatches => dispatch => {
    console.log('SETTING MATCHES NOW');

    dispatch({
        type: SET_MATCHES,
        payload: arrayOfMatches
    });
};

// Create Match
export const createSportsMatch = ({ 
    formData, 
    team_logos,
    group_id,
    search_tags
}) => async dispatch => {
    
    console.log('STARTING TO CREATE NEW SPORTS MATCH');

    if(!auth.currentUser?.uid) {
        throw new Error("Not authenticated");
    }

    try {

        // Extract the necessary data from the formData object
        const {
            team_1_name,
            team_2_name,
            start_day,
            start_time,
            sport_type,
            search_tags
        } = formData;

        let combinedDateTime = null;

        if(start_day) {
            combinedDateTime = new Date(`${start_day}${start_time ? `T${start_time}` : ''}`);
        }
        // Get Unix timestamp in milliseconds
        const start_date = combinedDateTime?.getTime();

        const search_tags_array = search_tags?.split(',').map(word => word?.trim()?.toLowerCase()).filter(word => word !== '') || [];

        // if(!group_id) throw new Error('No group data provided');

        console.log('ABOUT TO CREATE NEW SPORTS MATCH');

        // Create a new document in the "sports_matches" collection
        const result = await addDoc(sportsCollectionRef, {
            group_id: group_id || null,
            sport_type,
            team_1_name,
            team_2_name,
            search_tags: search_tags_array,
            start_date: start_date || null,
            start_time_tbd: !start_time,
            date: Date.now(),
            createdAt: serverTimestamp(),
            lastModified: serverTimestamp()
        });

        console.log('NEW SPORTS MATCH CREATED');

        // Mixpanel event tracking for post submission
        if (process.env.NODE_ENV === 'production') {
            mixpanel.track("Create Sports Match", {
                "Team 1": `${team_1_name}`,
                "Team 2": `${team_2_name}`,
                "Current User ID":  `${auth.currentUser?.uid}`
            });
        }
   
        // --- Add team logo images to sports match ---

        // Get the document reference for the post
        const docRef = doc(db, 'sports_matches', result.id);

        const {
            team_1_logo,
            team_2_logo,
        } = team_logos;
        
        // Upload Team 1 lLogo to storage

        // Create a storage reference for the image
        const storageRef_Team_1 = ref(storage, `media/sports_matches/${result.id}/team_1_logo/${team_1_logo.name}`);

        // Upload the image file to the storage
        await uploadBytesResumable(storageRef_Team_1, team_1_logo);

        console.log('Uploaded a blob or file for Team 1!');

        // Get the download URL of the uploaded image
        const imgPath_Team_1 = await getDownloadURL(storageRef_Team_1);

        // Upload Team 2 logo to storage

        // Create a storage reference for the image
        const storageRef_Team_2 = ref(storage, `media/sports_matches/${result.id}/team_2_logo/${team_2_logo.name}`);

        // Upload the image file to the storage
        await uploadBytesResumable(storageRef_Team_2, team_2_logo);

        console.log('Uploaded a blob or file for Team 2!');

        // Get the download URL of the uploaded image
        const imgPath_Team_2 = await getDownloadURL(storageRef_Team_2);

        //  Add logos to sports match

        await updateDoc(docRef, {
            logo_team_1: imgPath_Team_1,
            logo_team_2: imgPath_Team_2
        });

        // Set a timeout to give enough time for the post to be added
        setTimeout(() => {

            // Display an alert message to notify the user that the post was sent
            // dispatch(setAlert('Posted! Your post was sent.', 'okay'));
            window.location.href = `/vs/${result.id}`;
        }, 1000 );

        // --- END Add avatar to group ---

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err);
    //   dispatch({
    //     type: POST_ERROR,
    //     payload: { msg: err.response.statusText, status: err.response.status }
    //   });
    }
};

// Matches loading
export const setMatchesLoading = () => {
    return {
        type: MATCHES_LOADING
    }
}

// Remove current group info from state
export const clearMatch = () => dispatch => {
    dispatch({
        type: CLEAR_MATCH
    });

}

// Remove current group info from state
export const clearMatches = () => dispatch => {
    dispatch({
        type: CLEAR_MATCHES
    });

}

// Profile update loading
export const setMatchUpdateLoading = () => {
    return {
        type: MATCH_UPDATE_LOADING
    }
}

// Profile update loading
export const setMatchUpdateLoaded = () => {
    return {
        type: MATCH_UPDATE_LOADED
    }
}

// --- Infinite Scroll Functions ---

export const set_ShowBottomSpinner = (value) => dispatch => {

    dispatch({
        type: SET_SHOW_BOTTOM_SPINNER_4_MATCHES,
        payload: value
    });

}

export const set_LastPageDoc = (doc) => dispatch => {

    dispatch({
        type: SET_LAST_MATCH_DOC,
        payload: doc
    });

}

export const set_NoMoreMatches = (value) => dispatch => {

    dispatch({
        type: SET_NO_MORE_MATCHES,
        payload: value
    });

}

// --- END: Infinite Scroll Functions ---

// --- Helper functions ----

export const getMatchesBySportType_Helper = async ({ sport_type, group_id, lastPageDoc, page_size }) => {
    
    console.log('GETTING MATCHES BY SPORT TYPE');

    try {
        if(!sport_type) throw new Error('No sport type provided');

        // -- Only get matches that start today or in the future --

        // Get the exact start time of today (midnight)
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0); // Sets time to 00:00:00.000

        // Get Unix timestamp in milliseconds
        const startOfToday_Timestamp = startOfToday.getTime(); 

         // -- END: Only get matches that start today or in the future --

        let q;

        if(lastPageDoc) {
            // Create a query to fetch notifications for the current user, starting at the last visible document and fetch the next 3
            q = query(sportsCollectionRef, where("sport_type", "==", sport_type), where("group_id", "==", group_id || null), where("start_date", ">=", startOfToday_Timestamp), orderBy('start_date', 'asc'), startAfter(lastPageDoc || 0), limit(page_size));
        } else {
            q = query(sportsCollectionRef, where("sport_type", "==", sport_type), where("group_id", "==", group_id || null), where("start_date", ">=", startOfToday_Timestamp), orderBy('start_date', 'asc'), limit(page_size));
        }
        const snapshot = await getDocs(q);
        
        const groupsList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        console.log('GOT MATCHES BY SPORT TYPE', groupsList);

        return groupsList;

    } catch (err) {
        console.log("ERROR! COULDN'T GET MATCHES BY SPORT TYPE")
        console.log(err);

        throw new Error('Failed to get matches');
    }
};

// --- END: Helper Functions
